"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BigWigHeaderReader_1 = require("./BigWigHeaderReader");
exports.FileType = BigWigHeaderReader_1.FileType;
var BigWigReader_1 = require("./BigWigReader");
exports.BigWigReader = BigWigReader_1.BigWigReader;
//# sourceMappingURL=index.js.map